/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown> }} Earningsrefunded1Inputs */

const en_earningsrefunded1 = /** @type {(inputs: Earningsrefunded1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.amount} refunded`)
};

const de_earningsrefunded1 = /** @type {(inputs: Earningsrefunded1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.amount} erstattet`)
};

/**
* | output |
* | --- |
* | "{amount} refunded" |
*
* @param {Earningsrefunded1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const earningsrefunded1 = /** @type {((inputs: Earningsrefunded1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Earningsrefunded1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_earningsrefunded1(inputs)
	return de_earningsrefunded1(inputs)
});
export { earningsrefunded1 as "earningsRefunded" }